var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 21H21",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 5L19 9",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.174 6.81238C21.7027 6.2838 21.9998 5.56685 21.9999 4.81923C22 4.07162 21.7031 3.35459 21.1745 2.82588C20.6459 2.29717 19.929 2.00009 19.1813 2C18.4337 1.99991 17.7167 2.2968 17.188 2.82538L3.842 16.1744C3.60981 16.4059 3.43811 16.6909 3.342 17.0044L2.021 21.3564C1.99515 21.4429 1.9932 21.5347 2.01535 21.6222C2.03749 21.7097 2.08292 21.7896 2.14679 21.8534C2.21067 21.9172 2.29062 21.9624 2.37815 21.9845C2.46569 22.0065 2.55755 22.0044 2.644 21.9784L6.997 20.6584C7.31017 20.5631 7.59517 20.3925 7.827 20.1614L21.174 6.81238Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.9f8ea145f3a92dee7b8c2fefe8891aed.svg";
export { ForwardRef as ReactComponent };